import ApiService from "@/api.service";
import API from "@/API";



export const GET_LIST_USERS = "GET_LIST_USERS";
export const GET_DETAIL_USER = "GET_DETAIL_USER";
export const SET_LIST_USERS = "SET_LIST_USERS";
export const SET_DETAIL_USER = "SET_DETAIL_USER";

export const GET_LIST_USERS_BY_SEARCH = "GET_LIST_USERS_BY_SEARCH";
export const SET_LIST_USERS_BY_SEARCH = "SET_LIST_USERS_BY_SEARCH";

export const UPDATE_USERS = "UPDATE_USERS";


const state = {
    users: [],
    userDetail: {},
    userBySearch: [],
};

const getters = {
    users(state) {
        return state.users;
    },
    userDetail(state) {
        return state.userDetail;
    },

    userBySearch(state) {
        return state.userBySearch;
    },
    // pricing(state) {
    //     return state.pricing;
    // },

};

const actions = {
    [GET_LIST_USERS](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_USERS}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_USERS, data);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_USER](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_USER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_USER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_USERS_BY_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`${API.GET_LIST_USERS_BY_SEARCH}`, payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_USERS_BY_SEARCH, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_USERS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_USERS}/${payload.id}?_method=PUT`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_USERS](state, data) {
        state.users = data.data;

    },
    [SET_DETAIL_USER](state, data) {
        state.userDetail = data.data;
    },
    [SET_LIST_USERS_BY_SEARCH](state, data) {
        state.userBySearch = data.data;
    },
    // [SET_LIST_PRICING](state, data) {
    //     state.pricing = data.data;
    // },


};

export default {
    state,
    actions,
    mutations,
    getters
};